import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { Router, findRoute, extractParams } from './router/Router';
import { routes } from './config/routes';
import { LanguageProvider } from './contexts/languageStore';
import { Language } from './utils/i18n/i18n';

// Client-side hydration
if (typeof window !== 'undefined') {
  const root = document.getElementById('root');
  if (root) {
    // Get the current pathname from the server-rendered HTML
    const pathname = window.location.pathname;

    // Detect language from pathname
    const detectLanguage = (): Language => {
      if (pathname.startsWith('/ar')) return 'ar';
      return 'en';
    };

    const initialLanguage = detectLanguage();

    // Extract initial parameters from the current route
    const currentRoute = findRoute(pathname, routes);
    const initialParams = currentRoute ? extractParams(pathname, currentRoute) : {};

    hydrateRoot(root,
      <LanguageProvider initialLanguage={initialLanguage}>
        <Router
          routes={routes}
          initialPathname={pathname}
          initialParams={initialParams}
        />
      </LanguageProvider>
    );
  }
}
